import Vue from "vue";

const State = {
    namespaced: true,
    state: {
        latests: [],
        messages: [],
    },
    actions: {
        saveMessages(context, messages) {
            Vue.axios.post(window.urlapi + "messages", messages).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                    }
                    context.commit("GETMESSAGES", response.data.data);
                },
            );
        },
        setMessages(context, messages) {
            context.commit("GETMESSAGES", messages);
        },
        getMessages(context) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "messages").then(
                    response => {
                        context.commit("GETMESSAGES", response.data.data);
                        resolve(response.data.data);
                    },
                );
            })
        },
        getLatestMessage(context) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "messages/latests").then(
                    response => {
                        context.commit("GETLATESTMESSAGE", response.data.data);
                        resolve(response.data.data);
                    },
                );
            })
        },
        deleteMessage(context, id) {
            return Vue.axios.delete(window.urlapi + "messages/" + id).then(
                response => {
                    if (response.data && response.data.success === true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        const deletedId = response.data.data && response.data.data.id
                            ? response.data.data.id
                            : id;
                        context.commit("REMOVEMESSAGE", deletedId);
                    }
                    return response.data;
                },
            );
        },
    },
    mutations: {
        GETMESSAGES: (state, messages) => {
            state.messages = messages;
        },
        GETLATESTMESSAGE: (state, message) => {
            state.latests = message;
        },
        REMOVEMESSAGE: (state, id) => {
            state.messages = state.messages.filter(message => message.id !== id);
        },
    },
    getters: {
        messages: state => {
            return state.messages;
        },
        latests: state => {
            return state.latests;
        },

    },
    modules: {}
};

export default State;
